import React from 'react';
import styles from './ResultBox.module.css';

/**
 * ResultBox — caja que muestra el resultado de una función.
 *
 * @param {string}  label       - Etiqueta superior
 * @param {string}  value       - Texto a mostrar
 * @param {'ok'|'true'|'false'|'neutral'} variant - Color de estado
 */
function ResultBox({ label, value, variant = 'neutral' }) {
  return (
    <div className={styles.wrapper}>
      {label && <span className={styles.label}>{label}</span>}
      <div className={`${styles.box} ${styles[variant]}`}>
        {value || <span className={styles.placeholder}>—</span>}
      </div>
    </div>
  );
}

export default ResultBox;
